import React from 'react';
import { inject, observer } from 'mobx-react';
import H5ManagePermissions from './h5';
import PCManagePermissions from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';
import type { ThreadConversionPayload } from '@components/threadConversion';

interface ManagePermissionsProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    // 基础属性
    id: any
    threadData?: any
    topicList?: any[]
    className?: string;
    
    // 状态属性
    isSelf?: boolean;
    isApproved?: boolean;
    isEssence?: boolean;
    isSticky?: boolean | number;
    isSink?: boolean;
    isHidden?: boolean;
    isDisplay?: boolean;
    isHot?: boolean;
    isRecommend?: boolean;
    isProhibited?: boolean;
    stickyType?: any // 置顶类型
    stickyAt?: any  // 置顶时间
    type?: number;

    deletePopupStatus?: boolean  // 删除弹框是否显示
    
    // 权限控制
    canEdit?: boolean;
    canDelete?: boolean;
    canEssence?: boolean;
    canStick?: boolean;
    canSolve?: boolean;
    canSink?: boolean;
    canHidden?: boolean;
    canDisplay?: boolean;
    canHot?: boolean;
    canRecommend?: boolean;
    canProhibitedComment?: boolean;
    canConvert?: boolean;
    
    // 操作函数
    handleSetState?: any
    // handleEdit?: Function;  // 编辑
    handleDelete?: Function;  // 确认删除
    handleEssence?: Function; // 精华
    handleStick?: Function; // 确认置顶
    //   handleSolve?: Function;  // 帮他处理
    handleSink?: Function;  // 沉帖
    handleHidden?: Function;  // 隐藏本帖
    handleDisplay?: Function; // 屏蔽
    //   handleHot?: Function;  // 热门
    handleSite?: Function;  // 推荐
    //   handleProhibited?: Function; // 禁止评论
    handleReport?: Function;  // 确认举报
    handelManageClose?: Function;  // 关闭管理弹框
    handleConvert?: (payload: ThreadConversionPayload) => Promise<void>;
}

type ManagePermissionsAllProps = ManagePermissionsProps & RouteComponentProps;
@inject('app', 'site', 'user', 'thread')
@observer
// 下载APP入口，h5是悬浮在页面顶部，pc是放在页面内容右侧
class ManagePermissions extends React.Component<ManagePermissionsAllProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('这是header');
    }

    // 编辑，跳转到发布页
    handleEdit = () => {
        const { id, threadData } = this.props;
        // 图文帖正文允许包含视频，编辑限制应根据帖子类型判断。
        if (Number(threadData?.type) === 3) {
            Toast.info({ content: '当前仅支持在App端编辑视频帖' });
            return false;
        }
        if(threadData?.type == 1) { // 如果是动态，不允许在web端编辑
            Toast.info({content: '当前仅支持在App端编辑动态帖'});
            return false;
        } else if(threadData?.type == 0) {  // 图文帖
            this.props.history && this.props.history.push(`/setPost?id=${id}`);
        } else  if(threadData?.type == 2) { // 反馈帖
            this.props.history && this.props.history.push(`/setFeedbackPost?id=${id}`);
        }
        
    };

    // 获取帖子详情
    getThreadDetail = (code = '') => {
        const {thread, user, id } = this.props;
        if (thread) {
            return thread.getThreadDetail(id, code).then(res => {
                if(res.code == '403' || res.code == '404') {
                    let infoValue = '';
                    if(res.code == '403') { // 帖子状态异常
                        infoValue = '资源不存在';
                    } else if(res.code == '404') {
                        infoValue = '资源不存在';
                    }
                    Toast.info(infoValue);
                    setTimeout(() => {
                        window.ensureBack(
                            () => {
                            //   console.log('返回完成');
                            }
                          );
                    }, 1000)
                    
                } else if(res.code == 0) {
                    
                }
                return res;
            });
        }
    }

    // 返回上一页，如果没有上一页，返回到首页
    goBack = () => {
        console.log('返回上一页');
        window.ensureBack(() => {
            // console.log('返回完成');
        });
    }
    render() {
        // 帖子权限可能来自退出前的响应，不能单凭权限字段展示管理操作。
        if (!this.props.user?.userInfo?.code && !this.props.user?.userInfo?.id) return null;
        const { site, app, id, threadData, topicList, isSticky, ...props } = this.props;
        const platform = app?.platform || 'h5';
        
        if (platform === 'pc') {
            return <PCManagePermissions isSticky={isSticky} handleSetState={(data, rep) => this.setState({ ...data })} getThreadDetail={()=> this.getThreadDetail()} goBack={()=> this.goBack()} handleEdit={this.handleEdit} id={id} threadData={threadData} topicList={topicList} {...props} />;
        }
        
        return <H5ManagePermissions isSticky={isSticky} handleSetState={(data, rep) => this.setState({ ...data })} getThreadDetail={() => this.getThreadDetail()} handleEdit={this.handleEdit} id={id} threadData={threadData} {...props} />;

    }
}

export default withRouter(ManagePermissions);
